import { render, staticRenderFns } from "./UpdateAppointmentForm.vue?vue&type=template&id=2e530eb8&"
import script from "./UpdateAppointmentForm.vue?vue&type=script&lang=js&"
export * from "./UpdateAppointmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports